import * as fromDatatype from '../datatype-library/index';

export class app_psnl_menu_node_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  menu_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_level: fromDatatype.NumericDatatypeInterface;
  obj_sort_method: fromDatatype.VarcharDatatypeInterface;
  obj_sort_code: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  name_full: fromDatatype.VarcharDatatypeInterface;
  name_short: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  latest_access_date: fromDatatype.TimestampTzDatatypeInterface;
  login_subject_link_guid: fromDatatype.GuidDataFieldInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
}

export class app_psnl_menu_node_hdr_RowClass implements app_psnl_menu_node_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  menu_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_level: fromDatatype.NumericDatatypeInterface;
  obj_sort_method: fromDatatype.VarcharDatatypeInterface;
  obj_sort_code: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  name_full: fromDatatype.VarcharDatatypeInterface;
  name_short: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  latest_access_date: fromDatatype.TimestampTzDatatypeInterface;
  login_subject_link_guid: fromDatatype.GuidDataFieldInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
}